module.exports = __webpack_public_path__ + "static/media/bipedge-logo-white.74812fd7.svg";